function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M20.2943 18.1799C20.1063 18.1282 19.9135 18.1 19.7114 18.1C18.5032 18.1 17.5207 19.0827 17.5207 20.2911C17.5207 21.4995 18.5032 22.4823 19.7114 22.4823C20.9196 22.4823 21.9021 21.4995 21.9021 20.2911C21.9021 20.0889 21.8739 19.8914 21.8222 19.7081L27.9242 13.6048L28.9114 13.7365L32 10.6472L29.6636 10.3369L29.3533 8L26.2647 11.0892L26.3963 12.0767L20.2943 18.1799Z",
  fill: "currentColor"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M19.9464 16.0828L21.7517 14.2772C19.5375 13.5249 16.9848 14.0327 15.2219 15.8007C12.7444 18.2786 12.7444 22.3036 15.2219 24.7816C17.6993 27.2595 21.7235 27.2595 24.2009 24.7816C25.9685 23.0136 26.4762 20.4651 25.7241 18.2457L23.9189 20.0513C23.9847 21.208 23.5757 22.3882 22.6919 23.2722C21.0465 24.9179 18.3763 24.9179 16.7309 23.2722C15.0855 21.6265 15.0855 18.9557 16.7309 17.31C17.6147 16.426 18.79 16.017 19.9464 16.0828Z",
  fill: "currentColor"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "M27.2801 16.6941C28.761 19.8068 28.2109 23.639 25.6347 26.2157C22.3628 29.4883 17.06 29.4883 13.788 26.2157C10.5161 22.9431 10.5161 17.6392 13.788 14.3666C16.3642 11.7898 20.1956 11.2444 23.3077 12.7208L25.033 10.9952C20.9431 8.64888 15.6309 9.22253 12.138 12.7161C7.95401 16.901 7.95401 23.6813 12.138 27.8614C16.3219 32.0462 23.1009 32.0462 27.2801 27.8614C30.773 24.3678 31.3466 19.0545 29.0007 14.9637L27.2801 16.6941Z",
  fill: "currentColor"
});

var SvgAudienceCustom = function SvgAudienceCustom(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgAudienceCustom, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/audience_custom.f82698f9.svg";
export { ForwardRef as ReactComponent };